// extracted by mini-css-extract-plugin
export default {"section":"tB-z","inSectionButton":"uB-z","addressCard":"vB-z","disabled":"wB-z","cautionBox":"xB-z","failureBox":"yB-z","fade-out":"zB-z","successBox":"AB-z"};